import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCampaignGigs, fetchCampaignMilestones } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignGig, CampaignMilestonesResponse } from "types/campaign/milestones";
import { getErrorMessage } from "utils/helpers";


export const fetchCampaignMilestonesThunk = createAsyncThunk<{milestonesData: CampaignMilestonesResponse, campaignId: string}, string, { rejectValue: string }>(
    'campaign/milestones/fetch',
    async (campaignId, { getState, rejectWithValue }) => {
        const state = getState() as { auth: AuthState };
        try {
            const milestones = await fetchCampaignMilestones(state.auth.selectedAgencyId!, campaignId);
            return { milestonesData: milestones, campaignId };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)

export const fetchCampaignGigsThunk = createAsyncThunk<{gigs: CampaignGig[], campaignId: string}, string, { rejectValue: string }>(
    'campaign/milestones/fetchGigs',
    async (campaignId, { getState, rejectWithValue }) => {
        const state = getState() as { auth: AuthState };
        try {
            const gigs = await fetchCampaignGigs(state.auth.selectedAgencyId!, campaignId);
            return { gigs, campaignId };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)
